import { ReactNode } from 'react';
import { Button } from 'reactstrap';

interface FormActionsProps {
  onCancel: () => void;
  onSave: () => void;
  isSaveDisabled?: boolean;
  leftContent?: ReactNode;
}

export const FormActions = ({ onCancel, onSave, isSaveDisabled = false, leftContent }: FormActionsProps) => (
  <div className='d-flex justify-content-between align-items-center mt-3 pt-3 border-top'>
    <div>{leftContent}</div>
    <div className='d-flex gap-2'>
      <Button color='transparent' onClick={onCancel}>
        Cancel
      </Button>
      <Button color='primary' disabled={isSaveDisabled} onClick={onSave}>
        Save
      </Button>
    </div>
  </div>
);
